import React, { useEffect, useState } from "react";
import { PageHeader } from "./Pengumuman";
import { Image as ImageIcon, X, Plus, Trash2, Edit3 } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { galeriAPI } from "../lib/api";
import { useApp } from "../context/AppContext";
import { toast } from "sonner";
import { getWIBParts } from "../components/WIBClock";

const todayWIB = () => { const p = getWIBParts(); const BULAN = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"]; const m = BULAN.indexOf(p.bulan) + 1; return `${p.tahun}-${String(m).padStart(2, "0")}-${String(p.tanggal).padStart(2, "0")}`; };
const emptyForm = { title: "", url: "", date: "" };

const Galeri = () => {
  const { user } = useApp();
  const canManage = user.role === "admin" || user.role === "super_admin";
  const [items, setItems] = useState([]);
  const [preview, setPreview] = useState(null);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyForm);

  const load = () => galeriAPI.list().then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const openNew = () => { setEditing(null); setForm({ ...emptyForm, date: todayWIB() }); setOpen(true); };
  const openEdit = (g) => { setEditing(g); setForm({ title: g.title, url: g.url, date: g.date }); setOpen(true); };

  const handleFile = (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    if (f.size > 3 * 1024 * 1024) { toast.error("Maks 3MB"); return; }
    const r = new FileReader(); r.onload = (ev) => setForm((s) => ({ ...s, url: ev.target.result })); r.readAsDataURL(f);
  };

  const submit = async () => {
    if (!form.title || !form.url) { toast.error("Judul & gambar wajib"); return; }
    try {
      if (editing) { await galeriAPI.update(editing.id, form); toast.success("Foto diperbarui"); }
      else { await galeriAPI.create(form); toast.success("Foto ditambahkan"); }
      setOpen(false); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };
  const remove = async (id) => {
    if (!window.confirm("Hapus foto ini?")) return;
    try { await galeriAPI.remove(id); toast.success("Dihapus"); load(); } catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };

  return (
    <div>
      <PageHeader title="Galeri" subtitle="Dokumentasi kegiatan warga DM Residence" icon={ImageIcon}
        action={canManage && (
          <Dialog open={open} onOpenChange={setOpen}>
            <Button className="brand-btn" onClick={openNew}><Plus className="h-4 w-4 mr-1" />Tambah Foto</Button>
            <DialogContent><DialogHeader><DialogTitle>{editing ? "Edit Foto" : "Tambah Foto"}</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <div><Label>Judul Kegiatan</Label><Input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></div>
                <div><Label>Tanggal</Label><Input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} /></div>
                <div className="flex items-center gap-4">
                  {form.url ? <img src={form.url} alt="prev" className="h-24 w-24 rounded-xl object-cover shadow border" /> : <div className="h-24 w-24 rounded-xl bg-slate-100 grid place-items-center"><ImageIcon className="h-8 w-8 text-slate-400" /></div>}
                  <div><input type="file" accept="image/*" id="gal-img" className="hidden" onChange={handleFile} /><Label htmlFor="gal-img" className="inline-block cursor-pointer px-4 py-2 rounded-lg brand-btn text-white text-sm font-semibold">Unggah Foto</Label><div className="text-xs text-slate-500 mt-1">Maks 3MB</div></div>
                </div>
                <div><Label className="text-xs">Atau paste URL:</Label><Input value={form.url.startsWith("data:") ? "" : form.url} onChange={(e) => setForm({ ...form, url: e.target.value })} placeholder="https://..." /></div>
              </div>
              <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Batal</Button><Button onClick={submit} className="brand-btn">{editing ? "Simpan" : "Tambah"}</Button></DialogFooter>
            </DialogContent>
          </Dialog>
        )}
      />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {items.map((g) => (
          <div key={g.id} className="group relative overflow-hidden rounded-xl aspect-square bg-slate-100 shadow-sm">
            <button onClick={() => setPreview(g)} className="absolute inset-0 w-full h-full">
              <img src={g.url} alt={g.title} className="absolute inset-0 w-full h-full object-cover transition duration-300 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition" />
              <div className="absolute bottom-0 left-0 right-0 p-3 text-left text-white opacity-0 group-hover:opacity-100 transition"><div className="font-semibold text-sm">{g.title}</div><div className="text-xs opacity-80">{g.date}</div></div>
            </button>
            {canManage && <div className="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition"><Button size="sm" variant="secondary" className="h-7 w-7 p-0 bg-white/90" onClick={() => openEdit(g)}><Edit3 className="h-3 w-3" /></Button><Button size="sm" variant="secondary" className="h-7 w-7 p-0 bg-white/90 text-red-600" onClick={() => remove(g.id)}><Trash2 className="h-3 w-3" /></Button></div>}
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full text-center py-10 text-slate-400">Belum ada foto</div>}
      </div>
      {preview && (
        <div className="fixed inset-0 z-50 bg-black/80 grid place-items-center p-4" onClick={() => setPreview(null)}>
          <button className="absolute top-4 right-4 text-white/80 hover:text-white" onClick={() => setPreview(null)}><X className="h-6 w-6" /></button>
          <img src={preview.url} alt={preview.title} className="max-h-[85vh] max-w-full rounded-xl" />
        </div>
      )}
    </div>
  );
};
export default Galeri;
